import React from "react"

import { Link } from "gatsby"

import PostLinkTransformer from "./parsers/PostLinkTransformer"
import { Trans } from "gatsby-plugin-react-i18next"

import withRecombee from "../contexts/withRecombee"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ImageTransformer from "../components/parsers/ImageTransformer"

import { ChildSelector } from "../helpers/ChildSelector"

import * as blogLatestSectionStyles from "../styles/BlogLatestSection.module.css"

import metadataFilters from "./config/BlogLatestFiltersCfg.json"

import StandaloneSearchWidget from "./StandaloneSearchWidget"

import moment from "moment"

const withFeaturedImage = posts => {
  return posts.map(p => {
    let featuredImage = null
    if (
      p.featuredImage &&
      p.featuredImage.node &&
      p.featuredImage.node.localFile
    )
      featuredImage = getImage(p.featuredImage.node.localFile)

    p.thumbnail = featuredImage

    return p
  })
}

const relevant = (posts, filters) => {
  if (!filters || filters.length === 0) return withFeaturedImage(posts)

  const lowerCaseFilters = filters.map(f => f.toLowerCase())

  return withFeaturedImage(
    posts.filter(p => {
      return (
        p.categories.nodes.filter(t =>
          lowerCaseFilters.includes(t.name.toLowerCase())
        ).length > 0
      )
    })
  )
}

const businessUnitStyle = post => {
  const tagsList = post.categories.nodes

  const tags = tagsList.map(t => t.name.toLowerCase())

  if (tags.includes(`consulting`))
    return blogLatestSectionStyles.postItemConsulting
  if (tags.includes(`education`))
    return blogLatestSectionStyles.postItemEducation
  if (tags.includes(`technical`)) return blogLatestSectionStyles.postItemCode

  return ``
}

function BlogLatestSection(props) {
  const [activeFilters, setActiveFilters] = React.useState([])

  const { content, posts, pageContext } = props

  const title = ChildSelector.select(
    content,
    `latest-post-header`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const imageNode = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("latest-post-image")
  )[0]
  const imageContent = ImageTransformer(imageNode)

  const handleFilterToggle = filter => {
    if (activeFilters.indexOf(filter) === -1) {
      setActiveFilters([...activeFilters, filter])
    } else {
      setActiveFilters(activeFilters.filter(f => f !== filter))
    }
  }

  const handleReadPost = id => {
    if (props.recombee) {
      props.recombee.AddDetailView(`post-${id}`)
    }
  }

  return (
    <div className={`${props.className} ${blogLatestSectionStyles.wrapper}`}>
      <div className={`row ${blogLatestSectionStyles.headerWrapper}`}>
        <div className={`col-12 ${blogLatestSectionStyles.titleWrapper}`}>
          <h2
            className={`${blogLatestSectionStyles.title}`}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </div>
      </div>

      <div className={`row ${blogLatestSectionStyles.searchField}`}>
        <div className={`col-12 ${blogLatestSectionStyles.searchFieldWrapper}`}>
          <StandaloneSearchWidget />
        </div>
      </div>

      <div className={`row ${blogLatestSectionStyles.filters}`}>
        {Object.keys(metadataFilters).map((cat, idx) => (
          <div key={idx} className={`col-12 col-md-3`}>
            <p className={blogLatestSectionStyles.filterCategory}>{cat}</p>
            <div className={`row`}>
              <div className={`col-12 ${blogLatestSectionStyles.filtersGrid}`}>
                {metadataFilters[cat].map((filter, indx) => (
                  <span
                    key={indx}
                    className={`row ${blogLatestSectionStyles.filterSelector}`}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={activeFilters.includes(filter)}
                        onChange={() => handleFilterToggle(filter)}
                      />
                      {filter}
                    </label>
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={`row ${blogLatestSectionStyles.postList}`}>
        {(!posts || posts.length === 0) && <Trans>No posts found</Trans>}
        {posts &&
          relevant(posts, activeFilters).map(p => (
            <div
              key={p.id}
              className={`col-4 ${blogLatestSectionStyles.postItemWrapper
                } ${businessUnitStyle(p)}`}
            >
              <div className={`${blogLatestSectionStyles.postItemContent}`}>
                <p className={`${blogLatestSectionStyles.date}`}>
                  {moment(p.date).format("MMM d, yyyy")}
                </p>

                {/* <p className={`${blogLatestSectionStyles.author}`}>
                  Published by Cubewise Team
                </p> */}
                <div className={`${blogLatestSectionStyles.tagList}`}>
                  {p.tags &&
                    p.tags.nodes &&
                    p.tags.nodes.map((tag, indx) => (
                      <span
                        className={`${blogLatestSectionStyles.tag}`}
                        key={indx}
                      >
                        {tag.name}
                      </span>
                    ))}
                </div>
                <p className={`${blogLatestSectionStyles.title}`}>{p.title}</p>
                {p.thumbnail && (
                  <div className={`${blogLatestSectionStyles.featuredImage}`}>
                    <GatsbyImage image={p.thumbnail} alt={p.title} />
                  </div>
                )}
                <p
                  className={`${blogLatestSectionStyles.excerpt}`}
                  dangerouslySetInnerHTML={{
                    __html: p.excerpt,
                  }}
                ></p>
              </div>
              <div className={`${blogLatestSectionStyles.btn}`}>
                <Link
                  className={businessUnitStyle(p)}
                  onClick={() => handleReadPost(p.databaseId)}
                  to={PostLinkTransformer(
                    p.uri,
                    pageContext.language,
                    pageContext.i18n.defaultLanguage,
                    pageContext.i18n.languages
                  )}
                >
                  <Trans>Read full article</Trans>
                </Link>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default withRecombee(BlogLatestSection)
